import { useQuery } from '@apollo/client';
import { Timelapse } from '@mui/icons-material';
import { CircularProgress } from '@mui/material';
import { TimelineList, Widget, WidgetContent, WidgetHeader, WidgetIcon } from '@procureai/ui-mui';
import { useTranslation } from 'react-i18next';

import { I18nNamespace } from '~/common/types';
import { useConfig } from '~/components/ConfigProvider';
import { WidgetContentEmpty } from '~/components/WidgetContentEmpty/WidgetContentEmpty';
import { useSourcingCase } from '~/modules';

import { FlowStepItem } from './components/FlowStep';
import { SOURCING_CASE_FLOW_QUERY } from './SourcingCaseFlowWidget.gql';

export const SourcingCaseFlowWidget = () => {
  const { id } = useSourcingCase();

  const { t } = useTranslation(I18nNamespace.widgets, { keyPrefix: 'SourcingCaseFlowWidget' });
  const { negotiationFeed } = useConfig();
  const { pollInterval } = negotiationFeed;
  const { data, loading } = useQuery(SOURCING_CASE_FLOW_QUERY, {
    pollInterval: pollInterval && !isNaN(pollInterval) ? pollInterval * 1000 : 0,
    variables: {
      id,
    },
    skip: !id,
  });
  const flow = data?.tesseract.sourcingCase?.flow;
  const steps = flow?.steps?.filter((p) => !p.hidden) || [];

  return (
    <Widget>
      <WidgetHeader
        title={t('title')}
        icon={<WidgetIcon icon={<Timelapse fontSize="small" />} />}
        actionsLeft={loading ? <CircularProgress size={20} /> : undefined}
      />
      <WidgetContent>
        {flow ? (
          <TimelineList items={steps} renderItem={FlowStepItem} />
        ) : (
          <WidgetContentEmpty title={t('emptyState.title')} />
        )}
      </WidgetContent>
    </Widget>
  );
};
